import {SurveyDefinitionModel} from "data/models/survey";
import {BrandAssetsDescription} from "components/Survey/survey-sections-rendering-components/BrandAssetsTitles";

export const PREVIEWS_SURVEYS: SurveyDefinitionModel = {
  id: "previews",
  surveyQuestions: [
    {
      id: "brand-styles",
      title: "Here are your brand styles!",
      description: BrandAssetsDescription,
      kind: "view-brand-styles",
      maxScreenWidth: "md",
      required: false,
      backButtonText: null,
      nextButtonText: null,
      options: {
      },
    },
  ],
};
